import { render, staticRenderFns } from "./GraffidiApplicativiList.vue?vue&type=template&id=2d43e780"
import script from "./GraffidiApplicativiList.vue?vue&type=script&lang=js"
export * from "./GraffidiApplicativiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports